import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoodle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M53.7931 4.99999C55.089 21.6107 53.8768 53.0786 38.6608 46.0649C19.6408 37.2978 25.1869 15.3299 36.7211 22.164C46.7801 28.1241 35.7651 60.5162 20.7492 50.9555V50.9555C9.74992 43.9521 26.6891 40.3791 20.3962 51.7997C18.874 54.5621 15.955 57.0874 11.081 59.0826",
		stroke: "currentColor",
		strokeWidth: 3.425
	})
});
const ForwardRef = forwardRef(SvgDoodle);
export default ForwardRef;
